import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $container: document._$('.breadcrumbs--siplast'),
      $breadcrumbs: this.el._$('.breadcrumb__list')
    };

    this.currentPage = {
      $contenttype: document.head.querySelector('[name="contenttype"]')?.content,
      $title: document.head.querySelector('[name="navigationtitle"]')?.content,
      $url: document.location.href,
      $referrer: document.referrer
    }

    this.systemPage = {
      $title: document.head.querySelector('[name="systemspagetitle"]')?.content,
      $url: document.head.querySelector('[name="systemspageurl"]')?.content
    }

    this.solutionPage = {
      $title: document.head.querySelector('[name="solutionspagetitle"]')?.content,
      $url: document.head.querySelector('[name="solutionspageurl"]')?.content
    }

    this.handleHistory();
  }

  handleHistory() {
    let landing,
      listing;

    switch (this.currentPage.$contenttype) {
    case 'system-landing-page':
      window.localStorage.setItem('siplast_history_landing', JSON.stringify(this.currentPage));
      window.localStorage.removeItem('siplast_history_listing');
      break;
    case 'system-listing-page':
      landing = window.localStorage.getItem('siplast_history_landing');

      if (landing) {
        landing = JSON.parse(landing);
      }

      if (landing?.$url !== this.currentPage.$referrer) {
        window.localStorage.removeItem('siplast_history_landing');
      }

      window.localStorage.setItem('siplast_history_listing', JSON.stringify(this.currentPage));

      break;
    case 'system-detail-page':
      const breadcrumbs = [];
      landing = window.localStorage.getItem('siplast_history_landing');
      listing = window.localStorage.getItem('siplast_history_listing');

      breadcrumbs.push(
        {
          $url: `${window.location.protocol}//${window.location.host}`,
          $title: 'Home'
        }
      );

      if (listing) {
        listing = JSON.parse(listing);
        if (listing.$url.split('?')[0] === this.currentPage.$referrer.split('?')[0]) {
          listing.$url = this.currentPage.$referrer;
          if (landing) {
            landing = JSON.parse(landing);
            breadcrumbs.push(this.solutionPage);
            breadcrumbs.push(landing);
          } else {
            breadcrumbs.push(this.systemPage);
          }
          breadcrumbs.push(listing);
        } else {
          window.localStorage.removeItem('siplast_history_listing');
        }
      } else {
        window.localStorage.removeItem('siplast_history_landing');
      }

      if (breadcrumbs.length === 1) {
        breadcrumbs.push(this.systemPage);
      }

      breadcrumbs.push(
        {
          $title: this.currentPage.$title
        }
      );

      this.populateList(breadcrumbs);
      window.localStorage.removeItem('siplast_history_listing');
      window.localStorage.removeItem('siplast_history_landing');
      break;
    default:
      window.localStorage.removeItem('siplast_history_listing');
      window.localStorage.removeItem('siplast_history_landing');
      break;
    }
  }

  populateList(breadcrumbs) {
    const last = breadcrumbs.length - 1;
    if (breadcrumbs.length > 1) {
      let el = '';
      breadcrumbs.forEach((breadcrumb, index) => {
        el += '<li class="breadcrumb__list-item">';
        if (index === last) {
          el += `<a class="breadcrumb__link" aria-current="page" >${breadcrumb.$title}</a></li>`;
        } else {
          el += `<a tabindex="0" class="breadcrumb__link" href="${breadcrumb.$url}" aria-label="${breadcrumb.$title}">${breadcrumb.$title}</a>`;
          el += '<span aria-hidden="true" class="breadcrumb__separator"> <svg viewBox="0 0 120 120" class="breadcrumb-icon" width="16" height="16" role="presentation"><use xlink:href="#angle-right"></use></svg></span></li>';
        }
      });

      this.dom.$breadcrumbs.innerHTML = el;
    }
  }
}

export default Module;
